import React from 'react'

const About = () => {
  return (
    <div className='about' id='about'>
            <div className="mainTitle">
                <div className="lines">
                <div className="line"></div>
                <div className="line"></div>
    <div className="title">
       <h2> من نحن</h2>
    </div>
            </div>
        </div>
        <div className="container">
            <div className="mainContent">
                <div className="right">
                    <h1>المستشار <br /> علاء الدين حامد</h1>
                    <span>المحامي بالنقض</span>
                    <p>محامٍ بخبرة تمتد لأكثر من واحدٍ وعشرين عامًا في ساحة العدالة، جمع خلالها بين العلم، والخبرة، والرؤية الواضحة في ممارسة مهنة المحاماة، مؤمنًا بأن المحاماة رسالة قبل أن تكون مهنة، ورسالة لا يحملها إلا الأقوياء… أقوياء العزيمة، المتسلحون بالعلم، الذين لا يخشون في الحق لومة لائم.</p>
                    <h2>المؤهلات العلمية</h2>
                    <p>دبلومة القانون الخاص<br />
دبلومة القانون العام<br />
درجة الماجستير في القانون العام</p>
                </div>
            <div className="left"><img src="https://res.cloudinary.com/defcamc5x/image/upload/v1761244559/nqdzuwgrazubdlxgzpov.webp" alt="علاء الدين حامد" /></div>
            </div>
            <div className="flex">
                <div>
                    <h2>فلسفته في العمل</h2>
                <p>الإدارة القوية<br />
التسلح بالعلم<br />
بذل الجهد<br />
احترام آداب المهنة<br />
روح العمل الجماعي<br />
الابتكار<br />
السعي الدؤوب نحو الهدف<br />
   </p>             </div>
                <div>
                    <h2>ما يميز أسلوبه</h2>
                    <p>البساطة في الإيضاح<br />
الدبلوماسية في التعامل<br />
الهدوء والثقة بالنفس<br />
الإيمان بالهدف<br />
مهارة الإقناع<br />
قراءة وتحليل المواقف بعمق</p>
                </div>
                <div>
                    <h2>قيم ومبادئ</h2>
                    <p>النزاهة – الشرف – الصبر – السعي العلم – <br />
                    السرية التامة – حفظ الأمانات والأسرار<br />
                     وأخيرًا... الالتزام، الالتزام، الالتزام</p>
                </div>
            </div>
            <div className="certifiation">
                <img src="https://res.cloudinary.com/defcamc5x/image/upload/v1761246050/lxwsf26utl48kwe4ef9r.webp" alt="" />
                <img src="https://res.cloudinary.com/defcamc5x/image/upload/v1761246050/cixbvlpfvagpsnsmxjmk.webp" alt="" />
                <img src="https://res.cloudinary.com/defcamc5x/image/upload/v1761246051/hqn2o7f7fnk4mtpizjyn.webp" alt="" />
            </div>
                </div>
    </div>
  )
}

export default About